///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthLayerDTO } from '../../../generated/shared-types.model';
import { GtthReactiveTextbox } from '../../../shared/reactive-forms/input-text';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { GtthEntityNameValidation } from '../../../shared/directives/validation-functions/entity-name';

export class GtthLayerDtoModel implements GtthLayerDTO {
    public layerFullName: string;
    // generated value
    public readonly layerPrefix: string;

    constructor(
        public readonly layerIndex: number,
        public readonly layerName: string
    ) {
        this.layerPrefix = `Layer ${this.layerIndex + 1}`;
    }

    static getLayerNameField(isLayerNameUnique: (name: string) => boolean): GtthReactiveTextbox {
        return new GtthReactiveTextbox({
            key: 'layerFullName',
            label: 'Layer name',
            required: true,
            maxLength: 250,
            validationFn: Validators.compose([
                Validators.required,
                Validators.maxLength(250),
                GtthEntityNameValidation(/[^A-Za-z\d\s#@!;$&%()_+=.,~\-{}[\]^'`]/g),
                (control: AbstractControl): ValidationErrors | null => {
                    if (control.value) {
                        return isLayerNameUnique(control.value) ? null : { layerNameExists: { layerName: control.value } };
                    } else {
                        return null;
                    }
                }
            ])
        } as GtthReactiveTextbox);
    }

    public getFullName(): string {
        if (!this.layerFullName) {
            this.generateFullName();
        }
        return this.layerFullName;
    }

    private generateFullName(): void {
        this.layerFullName = this.layerPrefix + ' - ' + this.layerName;
    }
}
